'use client';
import { X } from 'lucide-react';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import {
  dismissOfficialPluginBanner,
  isOfficialPluginBannerDismissed,
  OFFICIAL_PLUGIN_BANNER_DISMISSED_EVENT,
} from '@/utils/pluginBanner';
import { analytics } from '@/lib/analytics';

const OfficialPluginBanner = () => {
  const [dismissed, setDismissed] = useState<boolean | null>(null);

  useEffect(() => {
    setDismissed(isOfficialPluginBannerDismissed());
    const onDismissedElsewhere = () => setDismissed(true);
    window.addEventListener(OFFICIAL_PLUGIN_BANNER_DISMISSED_EVENT, onDismissedElsewhere);
    return () =>
      window.removeEventListener(OFFICIAL_PLUGIN_BANNER_DISMISSED_EVENT, onDismissedElsewhere);
  }, []);

  const handleDismiss = () => {
    dismissOfficialPluginBanner();
  };

  if (dismissed !== false) return null;

  return (
    <div style={{ background: '#0000D0' }} className="relative text-white">
      <Link
        href="/plugin"
        className="block text-white no-underline"
        onClick={() => {
          analytics.capture('plugin.banner.clicked');
        }}
      >
        <div className="max-w-6xl px-3 sm:px-6 pr-10 mx-auto flex flex-row gap-3 py-2 justify-center items-center text-sm sm:text-base">
          <span className="flex-shrink-0 rounded bg-[#FFFF00] px-2 py-0.5 text-xs text-black">
            NEW
          </span>
          <span>Official TONE3000 Plugin</span>
        </div>
      </Link>
      <button
        type="button"
        onClick={handleDismiss}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-zinc-200 hover:text-white"
        aria-label="Dismiss banner"
      >
        <X size={20} />
      </button>
    </div>
  );
};

export default OfficialPluginBanner;
